import { useTranslation } from 'react-i18next';
import { useContactUs } from '@/shared/lib';
import { Button } from '@/shared/components';
import { DEFAULT_SUPPORT_EMAIL } from '@/shared/config';
import type { ElementType } from 'react';
import LogoIcon from '@/shared/assets/logo-icon.svg?react';

interface Props {
  title: string;
  description: string;
  icon: ElementType;
  homeLink?: string;
  onClick?: () => void;
}

export const SystemErrorScreen = ({
  title,
  description,
  icon,
  homeLink,
  onClick,
}: Props) => {
  const { t } = useTranslation();
  const { links } = useContactUs();

  const IconComponent = icon;

  return (
    <div className="flex flex-col justify-between items-center min-h-dvh w-full px-[2.4rem] md:px-[4.2rem] pt-[4.2rem] pb-[3rem] md:pb-[3.6rem]">
      <div className="flex justify-center w-full">
        <LogoIcon className="w-[13.6rem] h-auto" />
      </div>

      <div className="flex flex-col items-center justify-center text-center">
        <IconComponent className="w-[10.6rem] h-[10.6rem] mb-[3.6rem]" />

        <p className="hero5 text-primary mb-2">{title}</p>

        <p className="p3 text-secondary mb-[3.6rem] px-[1.3rem] md:px-[8rem]">
          {description}
        </p>

        {onClick ? (
          <Button
            asChild
            className="headline4 w-[23.3rem] h-[5.6rem] rounded-[1.2rem]"
            onClick={onClick}>
            {t('system.health.buttonText')}
          </Button>
        ) : (
          <Button
            asChild
            className="headline4 w-[23.3rem] h-[5.6rem] rounded-[1.2rem]">
            <a href={homeLink ?? '/'}>{t('system.health.buttonText')}</a>
          </Button>
        )}
      </div>

      <div className="flex flex-col md:flex-row items-center justify-center text-center md:gap-x-[0.4rem]">
        <span className="p3 text-secondary">
          {t('errorScreen.contactSupport.title')}
        </span>

        <div className="flex items-center justify-center gap-x-[0.4rem]">
          <span className="p3 text-secondary">
            {t('errorScreen.contactSupport.description')}
          </span>

          <Button variant="link" asChild className="p3 text-secondary px-0">
            <a href={links?.defaultRequest || ''}>{DEFAULT_SUPPORT_EMAIL}</a>
          </Button>
        </div>
      </div>
    </div>
  );
};
